<template>
	<div id="map-page" class="page">
		<l-map id="map-container" ref="map" :zoom="zoom" :center="currentPosition" :min-zoom="9">
			<l-tile-layer :url="tileUrl" :attribution="mapAttribution"></l-tile-layer>
			<l-marker-cluster ref="mapCluster">
				<l-marker ref="marker" :lat-lng="company.coords" v-for="company in companies" :key="`map-marker-${company.id}`" :icon="markerIcon" @click="setSelectedCompany(company, $event)" :id="`marker-${company.id}`">
				</l-marker>
			</l-marker-cluster>
			<l-marker :lat-lng="currentPosition" :icon="positionIcon"></l-marker>
			<l-control-zoom />

			<l-marker :lat-lng="selectedCompany.coords" :icon="markerIcon" v-if="selectedItemType == 'salespoint'" />
		</l-map>



		<div id="selected-company">
			<a href="#" class="button btn-position" @click="flyToCurrentPosition"><i class="fal fa-2x fa-crosshairs"></i></a>
			<div v-if="selectedCompany">
				<company-item :item="selectedCompany" :key="`company-${selectedCompany.id}`" v-if="selectedItemType === 'company'" />
				<shop-item :item="selectedCompany" :key="`salespoint-${selectedCompany.id}`" v-if="selectedItemType === 'salespoint'" />
				<div class="company-actions">
					<a :href="this.mapLink(selectedCompany.coords.lat, selectedCompany.coords.lng, selectedCompany.title)" target="_blank" class="button btn-nav-to-route"><i class="fal fa-directions"></i> Route starten</a>
				</div>
			</div>
		</div>

		<back-button fixed />
	</div>
</template>
<script>
	import L from 'leaflet'
	import Vue2LeafletMarkerCluster from 'vue2-leaflet-markercluster'
	import {LMap, LTileLayer, LMarker, LControlZoom} from 'vue2-leaflet'

	import BackButton from '@/components/BackButton.vue'

	export default{
		name: 'MapPage',
		components: {
			LMap,
			LTileLayer,
			LMarker,
			LControlZoom,
			'l-marker-cluster': Vue2LeafletMarkerCluster,
			BackButton,
			CompanyItem: () => import('@/components/lists/CompanyItem.vue'),
			ShopItem: () => import('@/components/lists/ShopItem.vue')

		},
		metaInfo() {
			return {
				title: this.$t('buttonActions.map') + ' | ' + 'Kärnten Card App',
				meta: [{
					property: 'og:title', content: this.$t('buttonActions.map') + ' | ' + 'Kärnten Card App'
				}, {
					property: 'og:site_name', content: 'Kärnten Card App'
				}, {
					property: 'og:url', content: window.location.href
				}, {
					property: 'og:image', content: "https://app.kaerntencard.at/img/kc-logo.png"
				},{
					property: 'og:description', content: ""
				}]
			}
		},
		data () {
			return {
				mapAttribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors | Routing with <a href="http://project-osrm.org/" target="_blank">OSRM</a>',
				selectedCompany: null,
				selectedItemType: 'company',
				tileUrl: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
				zoom: 9,
				markerIcon: L.divIcon({
					html: '<i class="fas fa-3x fa-map-marker-alt"></i>',
					className: 'custom-map-marker',
					iconAnchor: [12,38],
					popupAnchor: [0, -39]
				}),
				positionIcon: L.divIcon({
					html: '<i class="fas fa-smile-beam"></i>',
					className: 'custom-map-marker',
					iconAnchor: [12,38],
					popupAnchor: [0, -39]
				})
			}
		},
		computed: {
			currentPosition () {
				return this.$store.state.currentPosition
			},
			companies () {
				// entered map from bookmars --> only show the bookmarks companies
				if (this.$route.params && this.$route.params.filtered === 'bookmarks') {
					return this.$store.getters.getCurrentBookmarks
				}

				// bonusClubs
				if (this.$route.params && this.$route.params.entity === 'bonusClub') {
					if (this.$store.getters.getFilteredResultsCount('bonusClub') >= 1) {
						return this.$store.getters.getFilteredResults('bonusClub')
					}

					return this.$store.getters.getCurrentBonusClubCompanies
				}

				//salespoints
				if (this.$route.params && this.$route.params.entity === 'salespoints') {
					if (this.$store.getters.getFilteredResultsCount('salespoints') >= 1) {
						return this.$store.getters.getFilteredResults('salespoints')
					}
					return this.$store.getters.getCurrentSalespoints
				}

				// companies
				if (this.$store.getters.getFilteredResultsCount('companies') >= 1){
					return this.$store.getters.getFilteredResults('companies')
				}

				return this.$store.getters.getCurrentCompanies
			},
			navSelectedCompany () {
				if (this.$route.params && this.$route.params.id) {
					return this.$store.getters.getCompanyByID(this.$route.params.id)
				}

				return undefined
			}
		},
		methods: {
			navigateToSingleDestination(id) {
				let routerConfig = { name: 'single-destination', params: { uuid: id } }
				this.$store.dispatch('fetchCompany', { id: id })
					.then(() => this.$router.push(routerConfig))
					.catch((err) => console.error(err))
			},
			setSelectedCompany(c, event) {
				this.selectedCompany = c
				this.selectedItemType = 'company'

				document.querySelectorAll('.active').forEach(item => {
					item.classList.remove('active')
				})
				event.target.getElement().classList.add('active')
			},
			flyToCurrentPosition() {
				this.$refs.map.mapObject.flyTo(this.currentPosition)
			}
		},
		mounted (){
			this.$refs.map.mapObject.zoomControl.remove()
			
			if (this.currentPosition === undefined) {
				this.requestCurrentPosition()
					.then((pos) => this.$store.dispatch('updateCurrentPosition', pos))
			}


			if (this.$route.params && this.$route.params.id) {
				this.selectedCompany = this.$store.getters.getCompanyByID(this.$route.params.id)
				this.selectedItemType = 'company'

				// was not a company --> was a salespoint
				if (this.selectedCompany === null || this.selectedCompany === undefined) {
					this.selectedCompany = this.$store.getters.getSalespointByID(this.$route.params.id)
					this.selectedItemType = 'salespoint'
				}

				if (this.selectedCompany) {
					this.$refs.map.mapObject.flyTo(this.selectedCompany.coords)
					this.$refs.map.mapObject.setZoom(17)
				}
			}
		},
		watch: {
			selectedCompany: {
				handler: function() {
					this.$refs.map.mapObject.flyTo(this.selectedCompany.coords)
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~leaflet/dist/leaflet.css';
	@import '~leaflet.markercluster/dist/MarkerCluster.css';
	@import '~leaflet.markercluster/dist/MarkerCluster.Default.css';
		

	#map-page{


		#map-container{
			width: 100vw;
			height: 100vh;
			overflow: hidden;

			.custom-map-marker{
				border: none !important;
			}
		}




		#selected-company{
			position: fixed;
			bottom: 0;
			left: 0;
			right: 0;
			
			z-index: 1000;

			>div{
				background-color: $white;
			}

			text-align: right;

			.btn-position{
				background: $white;
				box-shadow: 0 0 3px rgba(0,0,0,.5);
				color: #222;
				border-radius: 10rem;
				width: 2.45rem;
				height: 2.45rem;
				margin-right: .75rem;
				padding: 0rem;
				padding-top: .25rem;
				margin-bottom: .75rem;


			}
			.company-actions{
				background: darken($light-gray, 2%);
				padding-left: .5rem;
				text-align: left;
				.btn-nav-to-route{
					margin: .5rem;
					color: get-color(primary);
					border-radius: 10rem;
					color: $white;
					box-shadow: 0 0 3px rgba(0,0,0,.5);
				}
			}

			li{
				margin-bottom:0;
				border: 0px;
				padding: 0.5rem 1em;
				text-align: left;
				transition: all 300ms ease;
			}

			@include breakpoint(medium) {
				max-width: rem-calc(650);
				margin: 0 auto;
			}
		}
	}
</style>